import * as Sentry from '@sentry/vue';
import {App} from 'vue';

export function initializeSentry(app?: App): void {
    const dsn = process.env.VUE_APP_SENTRY_DSN;

    if (dsn !== '') {
        Sentry.init({
            ...(app !== undefined ? {app} : {}),
            dsn,
            beforeSend(event) {
                // Safari + third-party tracking scripts (GA, LinkedIn) trigger false
                // unhandled promise rejections with CustomEvent objects instead of Errors
                if (
                    event.exception?.values?.some(
                        (e) => e.type === 'CustomEvent'
                            && e.value?.includes('Non-Error promise rejection'),
                    )
                ) {
                    return null;
                }

                // Mapy.cz panorama library has internal bugs (e.g. race conditions
                // in setImage) that we can't fix — filter out errors from their code
                const frames = event.exception?.values?.[0]?.stacktrace?.frames;
                if (frames?.some((frame) => frame.filename?.includes('api.mapy.cz'))) {
                    return null;
                }

                return event;
            },
        });
    }
}
